import { useConnectionStatus } from "@gbougakov/brief-ts/react";

export function ConnectionStatus() {
  const status = useConnectionStatus();

  if (status === "connected") return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 flex items-center justify-center py-1">
      <div className="flex items-center gap-2 px-3 py-1 rounded-full bg-surface-container-highest/90 backdrop-blur-sm">
        <span
          className={`w-2 h-2 rounded-full ${
            status === "connecting"
              ? "bg-yellow-400 animate-pulse"
              : "bg-red-400"
          }`}
        />
        <span className="text-xs text-on-surface-variant">
          {status === "connecting" ? "Connecting..." : "Offline"}
        </span>
      </div>
    </div>
  );
}
